export class Album {

    public id: Number;
    public nomeGaleria: string;
    public data: Date;
    public status: boolean;
    public log_usuario: Number;
    public log_data: Date;
   
    constructor(){ }
}


// WEBPACK FOOTER //
// ./src/app/model/album.ts